"use client";
import React from "react";
import { motion } from "framer-motion";
import Image from "next/image";

export default function IndustryVideoStats({ section, industryTitle }) {
  return (
    <section className="py-24 px-6 sm:px-12 lg:px-24 bg-white/5 relative overflow-hidden">
      <div className="container mx-auto">
        {/* Header with Stats */}
        <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-16 gap-8">
          <motion.h2 
            className="text-5xl md:text-7xl font-bold text-white leading-tight"
          >
            Next-level<br /> 
            <span className="text-[#f1833b]">{industryTitle.split(" ")[0]}</span>
          </motion.h2>
          
          <motion.div 
            className="flex items-center gap-6 bg-white/5 p-8 rounded-3xl border border-white/10 shadow-sm"
          >
            <div className="text-right">
              <h3 className="text-4xl font-bold text-white">{section.stats.split(" ")[0]}</h3>
              <span className="text-gray-400 uppercase tracking-widest text-xs font-bold">{section.stats.split(" ").slice(1).join(" ")}</span>
            </div>
            <Image src="/odoo/icons/blue_bank.svg" width={64} height={64} className="w-16 h-16 object-contain" alt="" />
          </motion.div>
        </div>

        {/* Content with Video */}
        <div className="grid lg:grid-cols-12 gap-16 items-center">
          <motion.div 
            className="lg:col-span-5 space-y-6"
          >
            <p className="text-xl text-gray-300 leading-relaxed">
              <strong className="text-white">Speed matters.</strong> Our {industryTitle.split(" ")[0]} app processes all operations in less than 90 milliseconds, faster than the blink of an eye.
            </p>
            <p className="text-xl text-gray-300 leading-relaxed">
              <strong className="text-white">Smart reconciliation.</strong> Never import bank statements manually again. Odoo integrates with 28,000 banks from all around the world!
            </p>
            <p className="text-xl text-gray-300 leading-relaxed">
              <strong className="text-white">95% of the transactions</strong> are matched automatically with the financial records.
            </p>
          </motion.div>

          <motion.div 
            className="lg:col-span-7 rounded-[2rem] overflow-hidden border-[8px] border-white/5 shadow-2xl relative group"
          >
            <video autoPlay loop muted className="w-full">
              <source src={section.video} type="video/mp4" />
            </video>
            <div className="absolute inset-0 bg-slate-900/10 group-hover:bg-transparent transition-all" />
          </motion.div>
        </div>
      </div>
    </section>
  );
}
